// src/config/gauges/centrifuga.js

export const centrifugaGaugeConfig = [
  // 1) Presión Succión C1 (psuccion_c1)
  {
    key: "presAbsolutaSuccion",
    title: "Pres. Succión",
    unit: "psig",
    ranges: [
      { min: 0,  max: 27.99,  color: "red" },     // Bajo / Alto (Rojo)
      { min: 28, max: 32.99,  color: "yellow" },  // Precaución (Amarillo)
      { min: 33, max: 40.99,  color: "green" },   // Óptimo (Verde)
      { min: 41, max: 68.99,  color: "yellow" },  // Precaución (Amarillo)
      { min: 69, max: 100, color: "red" },     // Muy Alto (Rojo)
    ],
  },

  // 2) Presión Descarga C1 (pdescarga_c1)
  {
    key: "presAbsolutaDescarga",
    title: "Pres. Descarga",
    unit: "psig",
    ranges: [
      { min: 0,   max: 88.99,  color: "red" },    // Bajo (Rojo)
      { min: 89,  max: 99.99, color: "yellow" }, // Precaución
      { min: 100, max: 125.99, color: "green" },  // Óptimo
      { min: 126, max: 131.99, color: "yellow" }, // Precaución
      { min: 132, max: 300, color: "red" },    // Muy Alto
    ],
  },

  // 3) Temp Proceso Entrada
  {
    key: "tempProcesoEntrada",
    title: "T. Proceso Entrada",
    unit: "°C",
    ranges: [
      { min: 0,  max: 4.99,  color: "red" },      // Muy Bajo
      { min: 5,  max: 6.99,  color: "yellow" },   // Precaución
      { min: 7,  max: 12.99, color: "green" },    // Óptimo
      { min: 13, max: 19.99, color: "yellow" },   // Precaución
      { min: 20, max: 100, color: "red" },      // Alto
    ],
  },

  // 4) Temp Proceso Salida
  {
    key: "tempProcesoSalida",
    title: "T. Proceso Salida",
    unit: "°C",
    ranges: [
      { min: 0,  max: 4.99,  color: "red" },      // Muy Bajo
      { min: 5,  max: 6.99,  color: "yellow" },   // Precaución
      { min: 7,  max: 12.99, color: "green" },    // Óptimo
      { min: 13, max: 19.99, color: "yellow" },   // Precaución
      { min: 20, max: 100, color: "red" },      // Alto
    ],
  },

  // 5) Temp Torre Entrada
  {
    key: "tempAguaTorreEntrada",
    title: "T. Torre Entrada",
    unit: "°C",
    ranges: [
      { min: 0,  max: 24.99, color: "red" },
      { min: 25, max: 27.99, color: "yellow" },
      { min: 28, max: 31.99, color: "green" },
      { min: 32, max: 34.99, color: "yellow" },
      { min: 35, max: 50, color: "red" },
    ],
  },

  // 6) Temp Torre Salida
  {
    key: "tempAguaTorreSalida",
    title: "T. Torre Salida",
    unit: "°C",
    ranges: [
      { min: 0,  max: 25.99, color: "red" },
      { min: 26, max: 30.99, color: "yellow" },
      { min: 31, max: 34.99, color: "green" },
      { min: 35, max: 37.99, color: "yellow" },
      { min: 38, max: 5000, color: "red" },
    ],
  },

  // 7) Temp Descarga C1
  {
    key: "tempDescarga",
    title: "T. Descarga C1",
    unit: "°C",
    ranges: [
      { min: 0,  max: 40.99, color: "red" },
      { min: 41, max: 45.99, color: "yellow" },
      { min: 46, max: 70.99, color: "green" },
      { min: 71, max: 90.99, color: "yellow" },
      { min: 91, max: 1500, color: "red" },
    ],
  },
];

